module.exports = __webpack_public_path__ + "img/max-file-content-image-search.0cae4de6.svg";